import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DMESGLOG} from "../../dmesglog/dmesglogData";
import {DmesglogDataService} from "../../dmesglog/dmesglogDataService";
import {CLIMATELOG, SelectionType} from "../climatelogData";
import {ClimatelogDataService} from "../climatelogDataService";
import {ExpansionPanelComponent} from "@progress/kendo-angular-layout";


@Component({
  selector: 'app-climatelog',
  templateUrl: './climatelog.component.html',
  styleUrls: ['./climatelog.component.css']
})


export class ClimatelogComponent implements OnInit {
  @Input()
  panelOpenState = false;
  climateLog: CLIMATELOG[] | undefined;

  selections: Array<SelectionType> = [
    { name:"SETTINGC", value:(1<<0),  active: false },
    { name:"CREATE  ", value:(1<<1),  active: false },
    { name:"DEBUG   ", value:(1<<2),  active: false },
    { name:"INFO    ", value:(1<<3),  active: false },
    { name:"NOTE    ", value:(1<<4),  active: false },
    { name:"WARNING ", value:(1<<5),  active: true },
    { name:"ERROR   ", value:(1<<6),  active: true },
    { name:"CRITICAL", value:(1<<7),  active: true },
    { name:"NEVER   ", value:(1<<8),  active: false },
    { name:"ALARM   ", value:(1<<9),  active: true },
    { name:"UNKNOWN ", value:(1<<10), active: false }
  ];


  constructor(private climatelogDataService: ClimatelogDataService) {
  }

  onReload(event?: MouseEvent) {
    const evtMsg = event ? ' Event target is ' + (event.target as HTMLElement).textContent : '';
    this.panelOpenState = true;
    this.climatelogDataService.GetData(this.LogLevel()).subscribe({
      next: climateLogRoot => {
        this.climateLog = climateLogRoot.CLIMATE_LOG;
      }
    });
  }

  LogLevel(): number
  {
    var logLevel: number = 0;
    this.selections.forEach((item => {
      if(item.active)
          logLevel += item.value;
    }))
    return logLevel;
  }

  ngOnInit(): void {
    this.climatelogDataService.GetData(this.LogLevel()).subscribe({
      next: climateLogRoot => {
        this.climateLog = climateLogRoot.CLIMATE_LOG;
      }
    });
  }


}
